import type { UniclientProgress } from '@lemonade-hq/uniclient-chat';
import { useMemo } from 'react';

export const useCurrentIndex = (targetId: string | undefined, items?: UniclientProgress['items']): number =>
  useMemo(() => items?.findIndex(item => item.id === targetId) ?? -1, [targetId, items]);
